function l(e) {
  return e.content.cloneNode(!0);
}
function r(e, o) {
  var _n$firstChild;
  var t = e.querySelector("[slot=\"".concat(o, "\"]"));
  if (!t) return null;
  var n = t.cloneNode(!0);
  return t.remove(), (_n$firstChild = n.firstChild) !== null && _n$firstChild !== void 0 && (_n$firstChild = _n$firstChild.parentElement) !== null && _n$firstChild !== void 0 && _n$firstChild.removeAttribute("slot"), n;
}
export { r as cloneNamedSlotContent, l as cloneTemplateContent };